import { importProvidersFrom } from '@angular/core'
import { Routes } from '@angular/router'

import { EffectsModule } from '@ngrx/effects'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import * as fromStore from '@flowx/designer/shared/store'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

import { FlxReusableTemplateInstanceComponent } from '../reusable-ui-template/pages/reusable-template-instance/reusable-template-instance.component'

export const RuntimeReusableUiTemplateInstanceRoutes: Routes = [
  {
    path: 'ui-templates/:reusableTemplateResourceId/instance',
    canActivate: [DefaultApplicationPermissionsGuard('ui_template_read')],
    component: FlxReusableTemplateInstanceComponent,
    data: {
      [LayoutOptions.HAS_TOP_BANNER]: false,
      [LayoutOptions.IS_RUNNING_INSTANCE]: true,
    },
    providers: [
      importProvidersFrom(EffectsModule.forFeature([fromStore.reusableUiTemplateDataModelEffects])),
    ],
  },
]
